import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Loader2, ArrowLeft, Wand2, ImageOff } from "lucide-react";
import Navbar from "@/components/Navbar";
import { api } from "@/lib/api";

const abs = (u) => (!u ? "" : u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

export default function CategoryBrowse() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(undefined);

  useEffect(() => { api.igBrowseSlug(slug).then(setData).catch(() => setData(null)); }, [slug]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      <div className="mx-auto max-w-[1200px] px-5 py-10 sm:px-6">
        <Link to="/instagram-post-maker" className="mb-5 inline-flex items-center gap-1 text-sm text-white/60 hover:text-white"><ArrowLeft size={16} /> Post Maker</Link>
        {data === undefined ? (
          <div className="flex justify-center py-24"><Loader2 className="animate-spin text-[#E1306C]" /></div>
        ) : data === null ? (
          <div className="py-24 text-center" data-testid="browse-notfound"><ImageOff className="mx-auto mb-3 text-white/25" size={36} /><h1 className="text-xl font-bold">Category not found</h1><p className="mt-1 text-sm text-white/50">This category may be unpublished or renamed.</p></div>
        ) : (
          <>
            <h1 className="font-display text-4xl font-black tracking-tight" data-testid="browse-title">{data.category.name}</h1>
            <p className="mt-2 text-sm text-white/50">{data.templates.length} template{data.templates.length === 1 ? "" : "s"} · shareable link: <span className="text-[#8B5CF6]">/templates/{data.category.slug}</span></p>
            {data.templates.length === 0 ? (
              <div className="py-20 text-center text-white/40" data-testid="browse-empty">No templates in this category yet.</div>
            ) : (
              <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-testid="browse-grid">
                {data.templates.map((t) => (
                  <div key={t.id} data-testid={`browse-tpl-${t.id}`} className="group overflow-hidden rounded-xl border border-white/10 bg-white/[0.03]">
                    <div className="aspect-square overflow-hidden bg-black/40">
                      <img src={abs(t.thumbnail_url || t.image_url)} alt={t.name} className="h-full w-full object-cover transition-transform group-hover:scale-105" />
                    </div>
                    <div className="p-3">
                      <div className="truncate text-sm font-bold text-white">{t.name}</div>
                      <div className="mt-0.5 flex flex-wrap gap-1">{(t.categories || []).slice(0, 3).map((c) => <span key={c} className="rounded-full bg-[#E1306C]/15 px-1.5 py-0.5 text-[9px] font-semibold text-[#f48fb1]">{c}</span>)}</div>
                      <button onClick={() => navigate("/instagram-post-maker")} data-testid={`browse-use-${t.id}`} className="mt-2 inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-gradient-to-r from-[#E1306C] to-[#F77737] py-1.5 text-xs font-bold text-white"><Wand2 size={13} /> Use in Post Maker</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
